import axios from 'axios';
import store from '@/store';
import Config from '@/config';

//prod
// const host = 'https://api.novaposhta.ua/v2.0/json';
const host = Config.api_path;
//dev
// const host = 'https://my1.dev.npu.np.work/data/get/container/JSON';

const axiosInstance = axios.create({
  baseURL: host,
  method: 'post',
  timeout: 20000,
  headers: {
    Accept: '*/*',
    'Content-Type': 'application/json',
  },
});
axiosInstance.interceptors.response.use(
  config => {
    if (!config.data.success) {
      alert(config.data.errors[0]);
      return Promise.reject(config);
    }
    return config;
  },
  error => {
    if (error.response.status == 401) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      store.dispatch('auth').then(() => {});
    }
    return error;
  }
);

export default axiosInstance;
